import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { setFeature } from "@aws-sdk/core";
import { HttpRequest } from "@smithy/protocol-http";
import { ChecksumAlgorithm } from "./constants";
import { getChecksumAlgorithmForRequest } from "./getChecksumAlgorithmForRequest";
import { getChecksumLocationName } from "./getChecksumLocationName";
import { hasHeader } from "./hasHeader";
import { isStreaming } from "./isStreaming";
import { selectChecksumAlgorithmFunction } from "./selectChecksumAlgorithmFunction";
import { stringHasher } from "./stringHasher";
export var flexibleChecksumsMiddlewareOptions = {
  name: "flexibleChecksumsMiddleware",
  step: "build",
  tags: ["BODY_CHECKSUM"],
  override: true
};
export var flexibleChecksumsMiddleware = function flexibleChecksumsMiddleware(config, middlewareConfig) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var request, input, requestBody, headers, base64Encoder, streamHasher, requestChecksumRequired, requestAlgorithmMember, checksumAlgorithm, updatedBody, updatedHeaders, checksumLocationName, checksumAlgorithmFn, getAwsChunkedEncodingStream, bodyLengthChecker, rawChecksum, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (HttpRequest.isInstance(args.request)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", next(args));
              case 2:
                request = args.request, input = args.input;
                requestBody = request.body, headers = request.headers;
                base64Encoder = config.base64Encoder, streamHasher = config.streamHasher;
                requestChecksumRequired = middlewareConfig.requestChecksumRequired, requestAlgorithmMember = middlewareConfig.requestAlgorithmMember;
                checksumAlgorithm = getChecksumAlgorithmForRequest(input, {
                  requestChecksumRequired: requestChecksumRequired,
                  requestAlgorithmMember: requestAlgorithmMember
                }, !!context.isS3ExpressBucket);
                updatedBody = requestBody;
                updatedHeaders = headers;
                if (!checksumAlgorithm) {
                  _context.next = 35;
                  break;
                }
                _context.t0 = checksumAlgorithm;
                _context.next = _context.t0 === ChecksumAlgorithm.CRC32 ? 13 : _context.t0 === ChecksumAlgorithm.CRC32C ? 15 : _context.t0 === ChecksumAlgorithm.SHA1 ? 17 : _context.t0 === ChecksumAlgorithm.SHA256 ? 19 : 21;
                break;
              case 13:
                setFeature(context, "FLEXIBLE_CHECKSUMS_REQ_CRC32", "U");
                return _context.abrupt("break", 21);
              case 15:
                setFeature(context, "FLEXIBLE_CHECKSUMS_REQ_CRC32C", "V");
                return _context.abrupt("break", 21);
              case 17:
                setFeature(context, "FLEXIBLE_CHECKSUMS_REQ_SHA1", "X");
                return _context.abrupt("break", 21);
              case 19:
                setFeature(context, "FLEXIBLE_CHECKSUMS_REQ_SHA256", "Y");
                return _context.abrupt("break", 21);
              case 21:
                checksumLocationName = getChecksumLocationName(checksumAlgorithm);
                checksumAlgorithmFn = selectChecksumAlgorithmFunction(checksumAlgorithm, config);
                if (!isStreaming(requestBody)) {
                  _context.next = 30;
                  break;
                }
                getAwsChunkedEncodingStream = config.getAwsChunkedEncodingStream, bodyLengthChecker = config.bodyLengthChecker;
                updatedBody = getAwsChunkedEncodingStream(requestBody, {
                  base64Encoder: base64Encoder,
                  bodyLengthChecker: bodyLengthChecker,
                  checksumLocationName: checksumLocationName,
                  checksumAlgorithmFn: checksumAlgorithmFn,
                  streamHasher: streamHasher
                });
                updatedHeaders = _objectSpread(_objectSpread({}, headers), {}, {
                  "content-encoding": headers["content-encoding"] ? "".concat(headers["content-encoding"], ",aws-chunked") : "aws-chunked",
                  "transfer-encoding": "chunked",
                  "x-amz-decoded-content-length": headers["content-length"],
                  "x-amz-content-sha256": "STREAMING-UNSIGNED-PAYLOAD-TRAILER",
                  "x-amz-trailer": checksumLocationName
                });
                delete updatedHeaders["content-length"];
                _context.next = 35;
                break;
              case 30:
                if (hasHeader(checksumLocationName, headers)) {
                  _context.next = 35;
                  break;
                }
                _context.next = 33;
                return stringHasher(checksumAlgorithmFn, requestBody);
              case 33:
                rawChecksum = _context.sent;
                updatedHeaders = _objectSpread(_objectSpread({}, headers), {}, _defineProperty({}, checksumLocationName, base64Encoder(rawChecksum)));
              case 35:
                _context.next = 37;
                return next(_objectSpread(_objectSpread({}, args), {}, {
                  request: _objectSpread(_objectSpread({}, request), {}, {
                    headers: updatedHeaders,
                    body: updatedBody
                  })
                }));
              case 37:
                result = _context.sent;
                return _context.abrupt("return", result);
              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};